<template>
  <div>
    <Subheader title="Staff Activator Overview" />

    <div class="app-content-column">
      <div class="card">
        <h5>Search</h5>
        <div class="form">
          <input v-model="activatorsFilter.search" type="text" />
          <div class="center-div">
            <button class="large-button" @click="refreshData">Search</button>
          </div>
        </div>
      </div>

      <div class="card">
        <h5>Activators</h5>
        <Pagination
          style="margin-bottom: 1.25rem 0"
          :pagination-details="paginationDetails"
          :show-only-result-count="false"
          :hide-pages="true"
          @update="refreshData($event)"
        />
        <div class="table-container" style="margin-">
          <table>
            <tr>
              <th>Name</th>
              <th>Makers</th>
              <th></th>
            </tr>
            <tr v-for="activator in activators" :key="activator.id">
              <td>{{ activator.username }}</td>
              <td>
                <span v-for="maker in activator.aAssignedMakers" :key="maker.id">
                  {{ maker.username }}
                  <font-awesome-icon
                    v-if="maker.mActivator"
                    icon="times"
                    @click="removeActivator(maker.id, activator.id)"
                  />
                </span>
              </td>
              <td>
                <button class="table-btn" @click="toggleMakerModal(activator.id)">Add Maker</button>
              </td>
            </tr>
          </table>
        </div>
        <Pagination
          style="margin-bottom: 1.25rem 0"
          :pagination-details="paginationDetails"
          :show-only-result-count="false"
          :hide-pages="true"
          @update="refreshData($event)"
        />
      </div>

      <div v-if="showMakerModal" class="popup-overlay">
        <div class="popup-modal card" style="margin:0;">
          <div class="popup-close">
            <font-awesome-icon icon="times" @click="toggleMakerModal" />
          </div>
          <h5>Search Makers</h5>
          <Input v-model="makersFilter.search" placeholder="e.g. Jane Doe" @input="refreshData()" />
          <div v-for="maker in makers" :key="maker.id" class="name-list">
            <span v-if="maker.id === modalSelectedMaker">
              <font-awesome-icon icon="check"></font-awesome-icon>
            </span>
            <span @click="selectActivatorModal(maker.id)">{{ maker.username }}</span>
          </div>
          <button class="table-btn" @click="toggleMakerModal()">Hide Modal</button>
          <button
            v-if="modalSelectedMaker"
            class="table-btn"
            @click="assignActivator(modalSelectedMaker, modalActivator)"
          >
            Submit Maker
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/services/users'
import Subheader from '@/components/Subheader'
import Input from '@/components/Input'

import Pagination from '@/components/Pagination'
import { getPaginationDataFromResponse } from '@/services/utils/pagination'

export default {
  name: 'StaffActivatorOverview',
  components: {
    Subheader,
    Input,
    Pagination,
  },
  data() {
    return {
      showMakerModal: false,
      activatorsFilter: {
        isActivator: true,
        search: '',
      },
      makersFilter: {
        isMaker: true,
        search: '',
        // NRS 4.23.2020 -- This is a hack, but I am short on time!
        pageSize: 999999,
      },
      paginationDetails: {},
      activators: [],
      makers: [],
      modalSelectedMaker: null,
      modalActivator: null,
    }
  },
  created() {
    this.refreshData()
  },
  methods: {
    selectActivatorModal(makerId) {
      this.modalSelectedMaker = makerId
    },
    toggleMakerModal(activatorId = null) {
      if (this.showMakerModal) {
        this.showMakerModal = false
        this.modalActivator = null
        this.modalSelectedMaker = null
        return
      } else {
        this.showMakerModal = true
        this.modalActivator = activatorId
      }
    },
    assignActivator(makerId, activatorId) {
      User.api.addActivator(makerId, activatorId).then(this.refreshData())
      if (this.showMakerModal) {
        this.toggleMakerModal()
      }
    },
    removeActivator(makerId, activatorId) {
      User.api.removeActivator(makerId, activatorId).then(this.refreshData())
    },
    refreshData(page = null) {
      let filtersWithPageCount = { ...this.activatorsFilter }
      if (page) {
        filtersWithPageCount = { ...this.activatorsFilter, page: page }
      }

      User.api.list({ filters: filtersWithPageCount }).then(data => {
        this.activators = data.results
        this.paginationDetails = getPaginationDataFromResponse(data)
      })

      User.api.list({ filters: this.makersFilter }).then(data => {
        this.makers = data.results
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins/cards';
@import '../styles/mixins/containers';
@import '../styles/mixins/buttons';
@import '../styles/mixins/tables';
@import '../styles/mixins/popup';
@import '../styles/forms';

.card {
  @include card-w-borders();
  align-items: center;
  margin-top: 1.25rem;
}

.table-btn {
  @include base-button-small();
  float: right;
}

.name-list {
  padding: 0.5rem 0;
}

.bold-name {
  font-family: $base-bold-font-family;
  list-style-type: none;
  padding-bottom: 0.5rem;
}

.large-button {
  @include large-button();

  @media only screen and (max-width: $mobile-smallest-width) {
    width: 15rem;
  }
}

.center-div {
  width: 100%;
  text-align: center;
}

td {
  vertical-align: middle;
  min-width: 200px;
}

// .table-container {
//   overflow-x: scroll;
// }
</style>
